export const PremiumProgram = {
  ShopPromise: 'ShopPromise',
  WalmartSimplifiedShipping: 'WalmartSimplifiedShipping',
  TemuPreSale: 'TemuPreSale',
  TemuMadeToOrder: 'TemuMadeToOrder',
};
